export enum SubscriptionStatusCategory {
  PN_CONNECTED_CATEGORY = 'PNConnectedCategory',
  PN_RECONNECTED_CATEGORY = 'PNReconnectedCategory',
}
